import { render, staticRenderFns } from "./ConfirmOrder.vue?vue&type=template&id=64d4beef&scoped=true&"
import script from "./ConfirmOrder.vue?vue&type=script&lang=js&"
export * from "./ConfirmOrder.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmOrder.vue?vue&type=style&index=0&id=64d4beef&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d4beef",
  null
  
)

export default component.exports